import { template } from '../../template';

app.DictionaryWordListView = app.BaseListView.extend({
  subsTemplate: template('<div class="field-group"></div>'),

  initialize() {
    app.BaseListView.prototype.initialize.apply(this, arguments);

    this.listenTo(this.collection, 'reset', this.render);
    this.listenTo(this.collection, 'remove', this.render);
    this.listenTo(this.collection, 'add', this.render);
  },

  _layoutPanes() {
    app.BaseListView.prototype._layoutPanes.apply(this, arguments);

    // $listHeader contains all the subscription controls and must always be
    // shown even if there are no invoices.
    if (this.hasFetchedAllData() && this.$listHeader) {
      this.$listHeader.show();
    }
  },
});
